<template>
  <section class="sw-board">
    <header class="board-head">
      <div>
        <div class="title-row">
          <span class="title">板块战争 V3</span>
          <span class="badge">{{ visibleRows.length }}</span>
        </div>
        <div class="sub">点击板块查看王国扩张与纵深</div>
      </div>
      <div class="controls">
        <el-select v-model="statusFilter" size="mini" class="filter">
          <el-option label="全部板块" value="all" />
          <el-option label="扩张中" value="扩张中" />
          <el-option label="分歧" value="分歧" />
          <el-option label="修复" value="修复" />
        </el-select>
        <el-checkbox v-model="strongOnly">仅看强势</el-checkbox>
      </div>
    </header>

    <div class="rows">
      <article
        v-for="(row, idx) in visibleRows"
        :key="row.name"
        class="sw-row"
        :class="{ on: selected === row.name }"
        @click="selected = row.name"
      >
        <div class="col ident">
          <div class="ident-top">
            <span class="rank">{{ idx + 1 }}</span>
            <div class="name-block">
              <div class="name-line">
                <span class="name">{{ row.name }}</span>
                <span class="pill" :class="'st-' + row.statusKey">{{ row.status }}</span>
              </div>
              <div class="peak">{{ row.peak }}</div>
              <div class="peak-lab">龙头最高涨幅</div>
            </div>
          </div>
          <div class="ident-foot">
            <div><span>龙头连板</span><b>{{ row.leaderBoards }}</b></div>
            <div><span>补涨高度</span><b>{{ row.catchupHeight }}</b></div>
            <div><span>当前最高</span><b>{{ row.currentHigh }}</b></div>
          </div>
        </div>

        <div class="col">
          <div class="col-h"><i class="ico flag" />王国扩张</div>
          <div class="metric-3">
            <div><em>{{ row.gt5n }}</em><span>今日涨幅≥5%</span></div>
            <div><em>{{ row.limitUpN }}</em><span>今日涨停</span></div>
            <div><em>{{ row.gt15n }}</em><span>涨幅≥1.5%次数</span></div>
          </div>
          <div class="metric-4">
            <div><span>曾≥4B</span><b>{{ row.b4 }}</b></div>
            <div><span>曾3B</span><b>{{ row.b3 }}</b></div>
            <div><span>曾2B</span><b>{{ row.b2 }}</b></div>
            <div><span>连板晋级率</span><b class="red">{{ row.promo }}</b></div>
          </div>
        </div>

        <div class="col">
          <div class="col-h"><i class="ico crown" />王国接受度</div>
          <div class="prem-row">
            <div v-for="(p, i) in row.premiums" :key="'p' + i">
              <b class="red">{{ p.v }}</b>
              <span>{{ p.k }}</span>
            </div>
          </div>
          <div class="col-h sub"><i class="ico shield" />王国战损度</div>
          <div class="metric-4 loss">
            <div v-for="(d, i) in row.damage" :key="'d' + i">
              <span>{{ d.k }}</span>
              <b class="red">{{ d.v }}</b>
            </div>
          </div>
        </div>

        <div class="col veteran">
          <div class="vet-h">
            <span class="vet-ico" />
            <span>老臣战损</span>
            <span class="chev">›</span>
          </div>
          <div class="vet-grid">
            <div v-for="(cell, i) in row.veteran" :key="'v' + i" class="vet-cell">
              <span>{{ cell.k }}</span>
              <b :class="cell.tone">{{ cell.v }}</b>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="col-h"><i class="ico compass" />王国续航</div>
          <div class="endurance">
            <div>近10日 &gt; 1.5%：<b class="red">{{ row.gt15Days }}天</b></div>
            <div>近10日红盘率：<b class="red">{{ row.redRate }}</b></div>
          </div>
          <div class="bars">
            <i
              v-for="(h, i) in row.bars"
              :key="'bar' + i"
              :class="h > 0 ? 'up' : 'dn'"
              :style="{ height: Math.max(4, Math.abs(h)) + 'px' }"
            />
          </div>
        </div>

        <div class="col trend">
          <div class="col-h"><i class="ico chart" />板块指数趋势</div>
          <ul class="checks">
            <li v-for="(c, i) in row.checks" :key="'c' + i">
              <span class="mark" :class="c.ok ? 'ok' : 'no'">{{ c.ok ? '✓' : '×' }}</span>
              <span>{{ c.k }}</span>
            </li>
          </ul>
          <div class="ma-dev" :class="row.ma30Up ? 'red' : 'green'">距MA30偏离：{{ row.ma30 }}</div>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
const ROWS = [
  {
    name: '文化传媒',
    status: '扩张中',
    statusKey: 'expand',
    strong: true,
    peak: '+185.5%',
    leaderBoards: '11板',
    catchupHeight: '5板',
    currentHigh: '5B',
    gt5n: 18,
    limitUpN: 7,
    gt15n: 6,
    b4: 3,
    b3: 5,
    b2: 9,
    promo: '42%',
    premiums: [
      { k: '均溢价', v: '+4.8%' },
      { k: '2B次日', v: '+6.3%' },
      { k: '3B次日', v: '+5.1%' },
      { k: '高板次日', v: '+3.6%' }
    ],
    damage: [
      { k: '竞价低开', v: 5 },
      { k: '竞价深水', v: 8 },
      { k: '深水个股', v: 12 },
      { k: '跌停', v: 2 }
    ],
    veteran: [
      { k: '3日红K率', v: '68%', tone: 'red' },
      { k: '跌停数', v: '2', tone: 'green' },
      { k: '竞价低开数', v: '5', tone: 'ink' },
      { k: '竞价深水数', v: '8', tone: 'orange' },
      { k: '深水个股数', v: '12', tone: 'red' },
      { k: '跌停率', v: '6.1%', tone: 'green' },
      { k: '今日深水率', v: '18%', tone: 'orange' },
      { k: '近3日累计涨跌幅', v: '-4.2%', tone: 'green' }
    ],
    gt15Days: 7,
    redRate: '63%',
    bars: [8, 14, -6, 18, 10, -4, 16, 12, -8, 20],
    checks: [
      { k: '收盘 > MA5', ok: true },
      { k: '收盘 > MA10', ok: true },
      { k: '收盘 > MA30', ok: true },
      { k: '20日新高', ok: true },
      { k: 'MA多头排列', ok: true },
      { k: '量能放大', ok: false }
    ],
    ma30: '+8.2%',
    ma30Up: true
  },
  {
    name: 'AI应用',
    status: '分歧',
    statusKey: 'split',
    strong: false,
    peak: '+96.4%',
    leaderBoards: '7板',
    catchupHeight: '4板',
    currentHigh: '4B',
    gt5n: 11,
    limitUpN: 4,
    gt15n: 5,
    b4: 2,
    b3: 4,
    b2: 8,
    promo: '31%',
    premiums: [
      { k: '均溢价', v: '+2.1%' },
      { k: '2B次日', v: '+3.4%' },
      { k: '3B次日', v: '+1.8%' },
      { k: '高板次日', v: '-0.6%' }
    ],
    damage: [
      { k: '竞价低开', v: 7 },
      { k: '竞价深水', v: 11 },
      { k: '深水个股', v: 18 },
      { k: '跌停', v: 3 }
    ],
    veteran: [
      { k: '3日红K率', v: '52%', tone: 'red' },
      { k: '跌停数', v: '3', tone: 'green' },
      { k: '竞价低开数', v: '7', tone: 'ink' },
      { k: '竞价深水数', v: '11', tone: 'orange' },
      { k: '深水个股数', v: '18', tone: 'red' },
      { k: '跌停率', v: '8.5%', tone: 'green' },
      { k: '今日深水率', v: '22%', tone: 'orange' },
      { k: '近3日累计涨跌幅', v: '-6.8%', tone: 'green' }
    ],
    gt15Days: 4,
    redRate: '48%',
    bars: [12, -10, 6, -14, 8, 4, -12, 6, -8, 10],
    checks: [
      { k: '收盘 > MA5', ok: true },
      { k: '收盘 > MA10', ok: false },
      { k: '收盘 > MA30', ok: true },
      { k: '20日新高', ok: false },
      { k: 'MA多头排列', ok: false },
      { k: '量能放大', ok: true }
    ],
    ma30: '+2.4%',
    ma30Up: true
  },
  {
    name: '机器人',
    status: '修复',
    statusKey: 'repair',
    strong: false,
    peak: '+64.2%',
    leaderBoards: '5板',
    catchupHeight: '3板',
    currentHigh: '3B',
    gt5n: 9,
    limitUpN: 3,
    gt15n: 4,
    b4: 1,
    b3: 3,
    b2: 6,
    promo: '28%',
    premiums: [
      { k: '均溢价', v: '+1.6%' },
      { k: '2B次日', v: '+2.2%' },
      { k: '3B次日', v: '+0.9%' },
      { k: '高板次日', v: '+1.1%' }
    ],
    damage: [
      { k: '竞价低开', v: 4 },
      { k: '竞价深水', v: 6 },
      { k: '深水个股', v: 9 },
      { k: '跌停', v: 1 }
    ],
    veteran: [
      { k: '3日红K率', v: '61%', tone: 'red' },
      { k: '跌停数', v: '1', tone: 'green' },
      { k: '竞价低开数', v: '4', tone: 'ink' },
      { k: '竞价深水数', v: '6', tone: 'orange' },
      { k: '深水个股数', v: '9', tone: 'red' },
      { k: '跌停率', v: '3.4%', tone: 'green' },
      { k: '今日深水率', v: '14%', tone: 'orange' },
      { k: '近3日累计涨跌幅', v: '-1.8%', tone: 'green' }
    ],
    gt15Days: 5,
    redRate: '55%',
    bars: [-6, 8, 10, -4, 14, 6, -8, 12, 4, 9],
    checks: [
      { k: '收盘 > MA5', ok: true },
      { k: '收盘 > MA10', ok: true },
      { k: '收盘 > MA30', ok: false },
      { k: '20日新高', ok: false },
      { k: 'MA多头排列', ok: false },
      { k: '量能放大', ok: true }
    ],
    ma30: '-1.6%',
    ma30Up: false
  },
  {
    name: '商业航天',
    status: '扩张中',
    statusKey: 'expand',
    strong: true,
    peak: '+142.0%',
    leaderBoards: '8板',
    catchupHeight: '4板',
    currentHigh: '4B',
    gt5n: 14,
    limitUpN: 5,
    gt15n: 7,
    b4: 2,
    b3: 4,
    b2: 7,
    promo: '38%',
    premiums: [
      { k: '均溢价', v: '+5.2%' },
      { k: '2B次日', v: '+7.1%' },
      { k: '3B次日', v: '+4.4%' },
      { k: '高板次日', v: '+2.8%' }
    ],
    damage: [
      { k: '竞价低开', v: 3 },
      { k: '竞价深水', v: 5 },
      { k: '深水个股', v: 8 },
      { k: '跌停', v: 1 }
    ],
    veteran: [
      { k: '3日红K率', v: '74%', tone: 'red' },
      { k: '跌停数', v: '1', tone: 'green' },
      { k: '竞价低开数', v: '3', tone: 'ink' },
      { k: '竞价深水数', v: '5', tone: 'orange' },
      { k: '深水个股数', v: '8', tone: 'red' },
      { k: '跌停率', v: '2.8%', tone: 'green' },
      { k: '今日深水率', v: '11%', tone: 'orange' },
      { k: '近3日累计涨跌幅', v: '-2.1%', tone: 'green' }
    ],
    gt15Days: 8,
    redRate: '71%',
    bars: [10, 16, 8, 20, -5, 14, 18, 6, 12, 22],
    checks: [
      { k: '收盘 > MA5', ok: true },
      { k: '收盘 > MA10', ok: true },
      { k: '收盘 > MA30', ok: true },
      { k: '20日新高', ok: true },
      { k: 'MA多头排列', ok: true },
      { k: '量能放大', ok: true }
    ],
    ma30: '+11.4%',
    ma30Up: true
  }
]

export default {
  name: 'SectorWarBoard',
  data() {
    return {
      rows: ROWS,
      statusFilter: 'all',
      strongOnly: false,
      selected: '文化传媒'
    }
  },
  computed: {
    visibleRows() {
      return this.rows.filter((row) => {
        if (this.strongOnly && !row.strong) return false
        if (this.statusFilter !== 'all' && row.status !== this.statusFilter) return false
        return true
      })
    }
  }
}
</script>

<style scoped lang="scss">
.sw-board {
  margin-top: 10px;
  background: #f4f7fb;
  border-radius: 12px;
  padding: 12px;
  min-height: 640px;
}
.board-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}
.title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.title {
  font-size: 16px;
  font-weight: 800;
  color: #1f2d3d;
}
.badge {
  min-width: 22px;
  height: 18px;
  padding: 0 6px;
  border-radius: 9px;
  background: #1a73e8;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.sub {
  margin-top: 4px;
  font-size: 12px;
  color: #5b8def;
}
.controls {
  display: flex;
  align-items: center;
  gap: 12px;
}
.filter {
  width: 120px;
}
.rows {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.sw-row {
  display: grid;
  grid-template-columns: 168px 1.15fr 1.15fr 1.35fr 0.9fr 1.05fr;
  background: #fff;
  border: 1px solid #e4ebf5;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  &.on {
    border-color: #1a73e8;
  }
}
.col {
  padding: 10px 10px 8px;
  border-right: 1px solid #eef2f8;
  min-width: 0;
  &:last-child {
    border-right: 0;
  }
}
.ident-top {
  display: flex;
  gap: 8px;
}
.rank {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  background: #1a73e8;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.name-line {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.name {
  font-size: 15px;
  font-weight: 800;
  color: #1f2d3d;
}
.pill {
  font-size: 11px;
  line-height: 16px;
  padding: 0 6px;
  border-radius: 8px;
  &.st-expand {
    color: #e53935;
    background: #fdecea;
  }
  &.st-split {
    color: #ef6c00;
    background: #fff3e0;
  }
  &.st-repair {
    color: #1a73e8;
    background: #e8f1ff;
  }
}
.peak {
  margin-top: 4px;
  font-size: 20px;
  font-weight: 800;
  color: #e53935;
  line-height: 1.1;
}
.peak-lab {
  font-size: 11px;
  color: #8aa0c2;
}
.ident-foot {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  div {
    display: flex;
    flex-direction: column;
    font-size: 10px;
    color: #8aa0c2;
  }
  b {
    color: #1a73e8;
    font-size: 12px;
  }
}
.col-h {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 800;
  color: #1f2d3d;
  margin-bottom: 6px;
  &.sub {
    margin-top: 8px;
    color: #ef6c00;
  }
}
.ico {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  background: #1a73e8;
  display: inline-block;
  &.shield {
    background: #ef6c00;
  }
}
.metric-3,
.prem-row,
.metric-4 {
  display: grid;
  gap: 4px;
}
.metric-3 {
  grid-template-columns: repeat(3, 1fr);
  em {
    display: block;
    font-style: normal;
    font-size: 16px;
    font-weight: 800;
    color: #1a73e8;
  }
  span {
    font-size: 10px;
    color: #8aa0c2;
  }
}
.metric-4,
.prem-row {
  grid-template-columns: repeat(4, 1fr);
  margin-top: 8px;
  span {
    display: block;
    font-size: 10px;
    color: #8aa0c2;
  }
  b {
    font-size: 13px;
    color: #1f2d3d;
  }
}
.red {
  color: #e53935 !important;
}
.green {
  color: #2e7d32 !important;
}
.orange {
  color: #ef6c00 !important;
}
.ink {
  color: #1f2d3d !important;
}
.veteran {
  padding: 0;
  display: flex;
  flex-direction: column;
}
.vet-h {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  background: linear-gradient(90deg, #4da3ff 0%, #1a73e8 100%);
}
.vet-ico {
  width: 14px;
  height: 14px;
  border: 1.5px solid #fff;
  border-radius: 3px;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    left: 3px;
    top: 3px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #fff;
  }
}
.chev {
  margin-left: auto;
  font-size: 16px;
  line-height: 1;
}
.vet-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  padding: 8px;
}
.vet-cell {
  background: #f5f7fb;
  border-radius: 6px;
  padding: 4px 4px 6px;
  span {
    display: block;
    font-size: 10px;
    color: #8aa0c2;
    line-height: 1.2;
  }
  b {
    display: block;
    margin-top: 2px;
    font-size: 14px;
  }
}
.endurance {
  font-size: 12px;
  color: #4a5b73;
  line-height: 1.7;
}
.bars {
  display: flex;
  align-items: flex-end;
  gap: 3px;
  height: 28px;
  margin-top: 8px;
  i {
    width: 6px;
    border-radius: 1px;
    display: block;
    &.up {
      background: #e53935;
    }
    &.dn {
      background: #1a73e8;
    }
  }
}
.checks {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 8px;
  li {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    color: #4a5b73;
  }
}
.mark {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  color: #fff;
  font-size: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  &.ok {
    background: #2e7d32;
  }
  &.no {
    background: #e53935;
  }
}
.ma-dev {
  margin-top: 8px;
  text-align: right;
  font-size: 12px;
  font-weight: 700;
}
</style>
